<template>
  <div class="grid min-h-screen grid-cols-1 grid-rows-[auto_1fr_auto]">
    <Header />
    <slot />
    <Footer />
  </div>
</template>
